<template>
  <div class="avatar-container" :style="avatarContainerStyle">
    <div
      v-if="editable"
      :class="dragActive ? 'overlay drag-active' : 'overlay'"
    >
      <file-select
        @input-file="imageSelected"
        theme="dark"
        class="upload-container"
      />
    </div>
    <img
      class="avatar-image"
      :src="imageSrc"
      alt=""
    >
    <cropper
      v-if="editable"
      :md-active.sync="showCropper"
      :src="cropperImageSrc"
      @image-cropped="uploadCroppedImage"
    />
  </div>
</template>

<script>
import FileSelect from './FileSelect'
import Cropper from './Cropper'
export default {
  components: {
    FileSelect,
    Cropper
  },
  props: {
    src: {
      type: String,
      required: false
    },
    editable: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '100px'
    },
    height: {
      type: String,
      default: '100px'
    },
    borderRadius: {
      type: String,
      default: '3%'
    }
  },
  mounted () {
    window.addEventListener('dragenter', this.handleDragEnter)
    window.addEventListener('dragend', this.handleDragEnd)
    window.addEventListener('dragleave', this.handleDragLeave)
    window.addEventListener('drop', this.handleDrop)
  },
  data () {
    return {
      dragActive: false,
      showCropper: false,
      newImage: null
    }
  },
  computed: {
    avatarContainerStyle () {
      return `width: ${this.width}; height: ${this.height}; border-radius: ${this.borderRadius};`
    },
    imageSrc () {
      return this.src || '/static/profile_placeholder_male.png'
    },
    cropperImageSrc () {
      return this.newImage && this.newImage.blob ? this.newImage.blob : this.imageSrc
    }
  },
  methods: {
    handleDragEnter () {
      this.dragActive = true
    },
    handleDragEnd () {
      this.dragActive = false
    },
    handleDrop () {
      this.dragActive = false
    },
    openCroppingDialog () {
      this.showCropper = true
    },
    closeCroppingDialog () {
      this.showCropper = false
    },
    imageSelected (payload) {
      this.newImage = payload
      this.openCroppingDialog()
    },
    uploadCroppedImage (image) {
      image.name = 'avatar.jpeg'
      this.$store.dispatch('updateAvatar', {
        file: image
      })
      this.closeCroppingDialog()
    }
  }
}
</script>

<style lang="scss" scoped>
  .avatar-container {
    position: relative;
    overflow: hidden;
  }
  .avatar-image {
    height: 100%;
    width: 100%;
    object-fit: cover;
    object-position: center;
  }
  .overlay {
    height: 100%;
    width: 100%;
    position: absolute;
    z-index: 2;
    opacity: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover,
    &.drag-active {
      opacity: 1;
      background-color: rgba(0,0,0,0.3);
    }
    .upload-container {
      width: 100%;
      height: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Avatar.vue